module.exports = __webpack_public_path__ + "static/media/riskQuestion.cd67f62e.mp3";